var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumpy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4dabcf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m220.93 127.14-69.16-34.91-75.9 37.88 71.03 35.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.63 143.14 72.51 36.6-75.23 37.78-71.14-35.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.47 92.76 74.49 37.35-66.62 33.46-72.66-36.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.41 76.67-67.06-33.62-66.34 33.1 69.1 34.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.98 365.44v91.51l81.24-40.54-.09-91.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.1 292.91-.09-90.59-81.03 40.28v90.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.63 275.93v91.87l-69.29 34.58-.05-91.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.63 243.81v-90.02l-69.42 34.51.06 90.77z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m236.3 242.6-54.72-27.51v118.91s-66.92-142.39-73.12-155.18c-.8-1.65-4.09-3.46-4.93-3.9-12-6.3-47.16-24.11-47.16-24.11v210.08l48.64 26v-109.81s66.21 127.23 66.88 128.62 7.32 14.8 14.42 19.51c9.46 6.26 50 30.64 50 30.64z",
    fill: "#4d77cf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumpy);
export default __webpack_public_path__ + "static/media/numpy.27e847a90ad601dcdb83800a8587430f.svg";
export { ForwardRef as ReactComponent };